<template>
  <footer class="footer">
    <div class="footer__nav">
      <AppLink/>
      <ul class="footer__nav__link">
        <li>
          <a
            href="http://www.waseda.co.jp/company/profile"
            target="_blank">
            {{ textData[lang.key].footer.company }}
          </a>
        </li>
        <li>
          <BtnNews/>
        </li>
        <li
          v-if="lang.key === 'JP'">
          <BtnIntroduction/>
        </li>
      </ul>
    </div>
    <div class="footer__copyright">
      <p>Copyright (C) 2019 Waseda System Development Co., Ltd. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import AppLink from '@/components/molecules/AppLink'
import BtnIntroduction from '@/components/atoms/BtnIntroduction'
import BtnNews from '@/components/atoms/BtnNews'

export default {
  name: 'Footer',
  components: {
    mapGetters,
    AppLink,
    BtnIntroduction,
    BtnNews
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .footer {
    width: 100%;
    color: #FFFFFF;
    font-size: 15px;
    &__nav {
      background: #CC3454;
      padding: 70px 0 20px;
      & .store {
        width: fit-content;
        margin: auto;
      }
      & .store img {
        height: 48px;
      }
      & .store a:first-child {
        margin-right: 20px;
      }
      &__link {
        display: table;
        margin: 60px auto 0;
        & li {
          display: table-cell;
          padding-left: 70px;
        }
        & li:first-child {
          padding: 0;
        }
      }
    }
    &__copyright {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background: #222222;
      padding: 14px 0;
    }
  }
  @media (--breakPoint) {
    .footer {
      width: 100%;
      &__nav {
        padding: 30px 0 20px;
        &__link {
          display: table;
          margin: 20px auto 0;
          & li {
            display: block;
            height: 35px;
            padding-left: 0;
            text-align: center;
          }
          & li:first-child {
            padding: 0;
          }
        }
      }
      &__copyright {
        font-size: 10px;
        padding: 18px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Footer.vue